export default __webpack_public_path__ + "static/media/trouser.045b61e7.png";